import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { isDefined } from '@angular/compiler/src/util';
import { plainToClass } from 'class-transformer';
import { SettingService } from '../setting-service';
import { Bordereau } from '../../model/bordereau';
import { FluxStock } from '../../model/fluxstock';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class BordereauService {

  localBordereauSortie: Bordereau[];
  localBordereauEntree: Bordereau[];
  iSconnecting: boolean = false;

  iSsaving: boolean = false;
  iSgetListing: boolean = false;

  // saveBordereauEvent = new Subject<any>();

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              private settingService: SettingService,
              ) { }

  getBordereaux(to: string, from: string, type: string, state: string) {
    this.iSgetListing = true;
    return new Promise<Bordereau[]>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_BORDEREAUX(to, from, type, state),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Bordereau[]) =>  {
              const bordereaux = plainToClass(Bordereau, data);
              this.setLocalBordereau(type,  bordereaux);

              resolve(bordereaux);
              this.iSgetListing = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSgetListing = false;
            });
    });

    /* this.http.get(this.apiEndpoints.URL_GET_PRODUITS,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
      .subscribe(data => {
          // resolve(data);
          alert(JSON.stringify(data));
          // alert('ok');
        },
        err => {
          // console.log(err);
          alert(JSON.stringify(err));
    }); */

  }

  getBordereau(idbordereau: number) {

    this.iSconnecting = true;
    return new Promise<Bordereau>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_BORDEREAU(idbordereau),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Bordereau) =>  {
              const bordereau = plainToClass(Bordereau, data as object);
              resolve(bordereau);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
    });

  }


  saveBordereauAndFlux(bordereau: Bordereau, fluxstock: FluxStock[], valider: boolean) {

      this.iSsaving = true;

      const fluxStockList = [];

      // flux livré
      if (fluxstock !== undefined) {

        for ( let i = 0; i < fluxstock.length; i++) {

          const flux = {
            copyIdForUpdate: fluxstock[i].id,
            quantite: fluxstock[i].quantite,
            prixUnitaire: fluxstock[i].prix_unitaire,
            produit: fluxstock[i].produit.id,
            libelle: '',
            createBy: null,
            typeFlux: fluxstock[i].type_flux,
            dateFlux: this.sharedMethods.converStringToDatetime(fluxstock[i].date_flux),
            commentaire : '',
            valider: false,
            cloturer: false,
          };

          fluxStockList.push(flux);

        }

      }

      let id_facture: number;
      if (bordereau.facture !== undefined && bordereau.facture !== null) {
        id_facture = bordereau.facture.id;
      } else {
        id_facture = null;
      }


      const bord = {
        dateLivraison: this.sharedMethods.converStringToDatetime(bordereau.date_livraison),
        typeBordereau: bordereau.type_bordereau,
        note: bordereau.note,
        valider: valider,
        fluxStockList: fluxStockList,
        facture: id_facture,
      };


      if (bordereau.id !== 0) {

        return new Promise<Bordereau>(resolve => {
          this.http.patch(this.apiEndpoints.GET_URL_PATCH_BORDEREAUANDFLUX(bordereau.id), bord,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Bordereau) => {

                resolve(plainToClass(Bordereau, data as object));
                this.iSsaving = false;

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      } else {

        return new Promise<Bordereau>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_BORDEREAUANDFLUX, bord,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Bordereau) => {
                resolve(plainToClass(Bordereau, data as object));
                this.iSsaving = false;

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSsaving = false;
              });
        });

      }


    }



    deleteBordereau(bordereau: Bordereau, type: string) {

      this.iSconnecting = true;

      return new Promise<any>(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_BORDEREAU(bordereau.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {
              this.getBordereaux(this.settingService.to, this.settingService.from, type, '').then(bordereauX => {
                resolve(data);
                this.iSconnecting = false;
              });
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    }

    setLocalBordereau(type: string, Bordereaux: Bordereau[]) {
      if (type === 'entree')
      this.localBordereauEntree = Bordereaux ;

      if (type === 'sortie')
      this.localBordereauSortie = Bordereaux;
    }

    getLocalBordereau(type: string) {
      if (type === 'entree')
      return this.localBordereauEntree;

      if (type === 'sortie')
      return this.localBordereauSortie;
    }

    quantiteLivrer(fluxstock: FluxStock[]): number {

        let total = 0;

        if ( fluxstock !== null && fluxstock !== undefined) {


            for ( let i = 0; i < fluxstock.length; i++) {

                total += fluxstock[i].quantite;

            }


        }

        return total;

    }


    cmdLivreByProd( idproduit: number, fluxstock: FluxStock[] ): FluxStock {

        let total: FluxStock;

        if ( fluxstock !== null && fluxstock !== undefined) {

            for ( let i = 0; i < fluxstock.length; i++) {

                if (fluxstock[i].produit.id === idproduit && fluxstock[i].date_flux === undefined)
                total = fluxstock[i];

            }

        }

        return total;

    }

    indexCmdLivreByProd( idproduit: number, fluxstock: FluxStock[] ): number {

        let total: number;

        if ( fluxstock !== null && fluxstock !== undefined) {


            for ( let i = 0; i < fluxstock.length; i++) {

                if (fluxstock[i].produit.id === idproduit && fluxstock[i].date_flux === undefined)
                total = i;

            }


        }

        return total;

    }

}
